import React, { useEffect } from "react";
import { X } from "lucide-react";
import "./NavigationButtons.css";

const ExitButton = ({ onClick, title = "Exit", disabled = false }) => {
  useEffect(() => {
    if (disabled) return;
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClick();
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [onClick, disabled]);

  return (
    <button
      className="nav-button nav-button-exit"
      onClick={onClick}
      title={title}
      disabled={disabled}
    >
      <X size={18} strokeWidth={2} />
    </button>
  );
};

export default ExitButton;
